import { notificationsService } from "../entity/NotificationService";
import { toastService } from "src/libraries/toast";
import { getNotificationUseCase } from "./getNotificationUseCase";

export const sendNotificationUseCase = async (id: number) => {
    try {
        const response = await notificationsService.sendNotification(id);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {  
            // await getNotificationUseCase(id);
            return response;
        }
    } catch (error) {
        console.warn('getNotificationUseCase: ', error);
    }
}